module.exports = __webpack_public_path__ + "img/cover-jeu-05.3d014ab6.png";